import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

const labelTemplateUrl = "/label-templates";

export const fetchLabelTemplates = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const countRes = await rest.post(`${labelTemplateUrl}/count`, filterData);
            if (countRes.data.result?.data > 0) {
                let listRes = await rest.post(`${labelTemplateUrl}/list`, filterData);
                if (listRes.data && !listRes.data.succeeded) {
                    snackActions.snackBar({
                        message: `${listRes && listRes.data && listRes.data.message ? listRes.data.message : "Cannot fetch label templates."}`,
                        options: {
                            variant: 'warning'
                        }
                    });
                    return { data: [], count: 0 };
                }
                if (listRes.data && listRes.data.succeeded) {
                    return { data: listRes.data.result.data, count: countRes.data.result.data }
                }
            } else if (!countRes.data || !countRes.data.result) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch label templates."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return { data: [], count: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch label templates."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: [], count: 0 }
        }
    }
}

export const fetchLabelTemplate = id => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post(`${labelTemplateUrl}/load`, id);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data && res.data.message ? res.data.message : "Cannot fetch label template."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return {};
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch label template."}`,
                options: {
                    variant: 'error'
                }
            });
            return {};
        }
    };
};

export const createLabelTemplate = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post(`${labelTemplateUrl}/create`, params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created label template.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create label template."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editLabelTemplate = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post(`${labelTemplateUrl}/save`, params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated label template.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit label template."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const deleteLabelTemplate = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post(`${labelTemplateUrl}/delete`, params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted label template.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete label template."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot delete label template."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkDeleteLabelTemplates = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post(`${labelTemplateUrl}/bulk-delete`, params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted label templates.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete label templates."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
